import financialRatioTypesData from './financialRatioType.json';
import booleanGUIControlTypesData from './booleanGUIControlType.json';
import criterionSpecificationData from './criterionSpecification.json';
import currencyCodeListData from './currencyCode.json';
import EORoleTypeListData from './eORoleType.json';
import EOIDTypeListData from './eOIDType.json';
import EOIndustryClassificationListData from './eOIndustryClassificationCode.json';
import CountryCodeIdentifierData from './countryCodeIdentifier.json';
import translationsDefaultData from './translations.default.json';
export class Resources {
    static financialRatioTypes = financialRatioTypesData;
    static booleanGUIControlTypes = booleanGUIControlTypesData;
    static currencyCode = currencyCodeListData;
    static eORoleType = EORoleTypeListData;
    static eOIDType = EOIDTypeListData;
    static eOIndustryClassificationCode = EOIndustryClassificationListData;
    static countryCodeIdentifier = CountryCodeIdentifierData;
    static criterionSpecification = criterionSpecificationData;
    static translationsDefault = translationsDefaultData;
}
